import gql from 'graphql-tag';
import { milestoneFragment } from './fragments';

/*
*
*/
export const milestones = gql`
  query milestones($where: MilestoneWhereInput, $orderBy: MilestoneOrderByInput, $skip: Int, $after: String, $before: String, $first: Int, $last: Int) {
    milestones(where: $where, orderBy: $orderBy, skip: $skip, after: $after, before: $before, first: $first, last: $last) ${milestoneFragment}
  }
`;
